<template>
  <div>
    <div style="font-size: 15px!important;">
      {{ $t('base.product_campaign_detail') }} - Campaign ID:
      <strong style="font-size: 15px; cursor: pointer" class="text-danger"
              @click="copy_text(campaign && campaign.campaign ? campaign.campaign.campaignid : '' )">
        {{ campaign && campaign.campaign && campaign.campaign.campaignid }}
      </strong>
      - Product ID:
      <strong style="font-size: 15px; cursor: pointer" class="text-danger"
              @click="copy_text(campaign && campaign.product ? campaign.product.itemid : '' )">
        {{ campaign && campaign.product && campaign.product.itemid }}
      </strong>
    </div>
    <div style="font-size: 15px!important; margin-top: 10px">
      {{ $t('base.keyword') }}:
      <strong style="font-size: 17px; cursor: pointer" class="text-danger"
              @click="copy_text(keyword ? keyword.keyword : '')">
        {{ keyword ? keyword.keyword : '' }}
      </strong>
    </div>

    <div style="margin-top: 40px; display: flex; gap: 10px">
      <el-date-picker
        v-model="date_range" type="daterange" range-separator="-"
        style="width: 400px"
        :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')" size="mini"
        format="dd-MM-yyyy" :clearable="false"
        :picker-options="picker_options">
      </el-date-picker>
      <el-button type="primary" size="mini" icon="el-icon-search" :loading="loading.get_data"
                 @click="m__get_metrics()">{{ $t('base.analyze') }}
      </el-button>
    </div>

    <div style="margin-top: 30px">
      <div style="font-size: 12px; font-weight: 500">
        {{ $t('base.selected') }} {{ flag_list.filter(i => i.checked).length }}/{{ max_selected_metrics }}
        {{ $t('base.metrics') }}
      </div>
      <div style="margin-top: 10px; border: 1px solid #e5e5e5;border-radius: 4px; padding: 20px 10px 10px 10px">
        <div v-for="flag in flag_list" :key="flag.label"
             style="width: 20%; float: left; margin-bottom: 10px; font-size: 13px">
          <el-checkbox size="mini" v-model="flag.checked" @change="flag.checked = $event; m__get_metrics()"
                       class="cbx-black"
                       :disabled="(flag.checked === true && flag_list.filter(i => i.checked).length <= 1) || (!flag.checked && flag_list.filter(i => i.checked).length >= max_selected_metrics)">
            &nbsp;{{ flag.label }}
          </el-checkbox>
        </div>
        <div style="clear: both!important;"></div>
      </div>
    </div>

    <div style="margin: 10px 0">
      <div v-if="view_type === 'chart'">
        <highcharts :options="chart_options"></highcharts>
      </div>
      <div v-if="view_type === 'table'">
        <el-table :data="reports">
          <el-table-column prop="timestamp" :label="$t('base.time')" width="150px">
            <template slot-scope="scope">
              {{ scope.row.timestamp * 1000 |moment('DD-MM-YYYY') }}
            </template>
          </el-table-column>
          <template v-for="key in Object.keys(key_list)">
            <el-table-column :prop="'metrics.' + key" :label="key_list[key].name" width="300px" sortable>
              <template slot-scope="scope">
                {{ scope.row.metrics[key] | currency }} {{ percent_list.includes(key) ? '%' : '' }}
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import {base_flag, picker_options} from "../../../addon/options"
import {Chart} from "highcharts-vue";
import Highcharts from "highcharts";
import hcHeatmap from "highcharts/modules/heatmap";

hcHeatmap(Highcharts);

export default {
  name: 'component__keyword_metrics',

  props: {
    shop: {},
    campaign: {},
    keyword: null,
    keyword_metrics: false
  },

  components: {
    highcharts: Chart
  },

  data() {
    return {
      flag_list: [],
      date_range: [this.dayjs().subtract(1, 'week').toDate(), new Date()],
      picker_options: picker_options,
      loading: {
        get_data: false
      },
      default_checked_list: ['avg_rank'],
      max_selected_metrics: 1,
      reports: [],
      key_list: {},
      selected_key_list: [],
      color: [
        'rgb(54, 127, 227)',
        'rgb(246, 189, 22)',
        'rgb(35, 170, 171)',
        'rgb(88, 183, 241)',
        'rgb(251, 115, 75)',
        'rgb(148, 95, 185)',
        'rgb(215,81,82)',
        'rgb(105,39,255)',
      ],
      view_type: 'chart',
      reduce_100k_list: ['broad_gmv', 'direct_gmv', 'cost', 'cpc', 'cpdc'],
      percent_list: ['broad_cir', 'direct_cir', 'ctr', 'broad_cr', 'direct_cr'],

      chart_options: {
        chart: {
          type: "heatmap",
          marginTop: 40,
          marginBottom: 80,
          plotBorderWidth: 1,
          height: 1000
        },

        title: {
          text: ""
        },

        xAxis: {
          categories: []
        },

        yAxis: {
          categories: [],
          title: null
        },

        colorAxis: {
          min: 0,
          minColor: "#FFFFFF",
          maxColor: Highcharts.getOptions().colors[0]
        },

        legend: {
          enable: false,
          align: "right",
          layout: "vertical",
          margin: 0,
          verticalAlign: "top",
          y: 25,
          symbolHeight: 280
        },
        tooltip: {},
        series: [
          {
            borderWidth: 1,
            data: [],
            dataLabels: {
              enabled: true,
              color: "#000000"
            }
          }
        ]
      }
    }
  },

  beforeMount() {
    for (const flag of this.clone(base_flag)) {
      flag.checked = this.default_checked_list.includes(flag.value);
      this.flag_list.push(flag)
    }
  },

  watch: {
    'keyword_metrics': function () {
      if (this.keyword_metrics) {
        this.m__get_metrics()
      }
    }
  },

  methods: {
    async m__get_metrics() {
      this.reports = []
      this.key_list = {}
      this.selected_key_list = []

      this.loading.get_data = true;

      try {
        const form = {
          shop_id: this.shop._id,
          campaign_id: this.campaign.campaign.campaignid,
          keyword: this.keyword.keyword,
          start_time: this.dayjs(this.date_range[0]).unix(),
          end_time: this.dayjs(this.date_range[1]).unix(),
          metric_list: this.flag_list.filter(i => i.checked).map(i => i.value)
        };

        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/shopee_ads/get_hour_metrics_by_keyword', form, this.cf())
        // console.log(response.body.data)

        this.chart_options.xAxis.categories = response.body.data.map(i => i.label)

        const left_labels = []
        for (let i = 0; i <= 23; i++) {
          left_labels.push(this.dayjs().hour(i).startOf('hour').format('HH:mm'))
        }
        this.chart_options.yAxis.categories = left_labels.reverse()

        const result = []
        for (const [index, item] of response.body.data.entries()) {
          for (let i = 0; i <= 23; i++) {
            const col = [index, i]
            const found = item.data.find(ii => this.dayjs(ii.time * 1000).hour() === i)
            if (found) {
              col.push(found.metrics ? found.metrics.avg_rank : 0)
            } else {
              col.push(0)
            }
            result.push(col)
          }
        }
        // console.log(result)
        this.chart_options.series[0].data = result.reverse()
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.get_data = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/pas/component/component_keyword_metrics_by_hour.vue